import { Button } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';

export const CancelReservationModalFooter = ({
  onClose,
  handleConfirm,
  loading,
}: {
  onClose: () => void;
  handleConfirm: () => void;
  loading: boolean;
}): JSX.Element => {
  const { t } = useTranslation('peopleProfileSidebar', {
    keyPrefix: 'bookings.cancelReservationModal',
  });

  return (
    <>
      <Button key="keep" onClick={onClose}>
        {t('keep_booking')}
      </Button>

      <Button
        danger
        type="primary"
        key="cancel"
        onClick={handleConfirm}
        loading={loading}
      >
        {t('cancel_booking')}
      </Button>
    </>
  );
};
